import { render, staticRenderFns } from "./ChangeEmailPage.vue?vue&type=template&id=079fc47b&scoped=true"
import script from "./ChangeEmailPage.vue?vue&type=script&lang=ts"
export * from "./ChangeEmailPage.vue?vue&type=script&lang=ts"
import style0 from "./ChangeEmailPage.vue?vue&type=style&index=0&id=079fc47b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fc47b",
  null
  
)

export default component.exports